import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row px-4 py-2 pb-0 g-0"
}
const _hoisted_2 = { class: "col-12 offset-lg-1 col-lg-10 mb-1 row g-0" }
const _hoisted_3 = { class: "form-group col-12 pe-lg-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "patient-tags" }, " Tags ", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TagsInput = _resolveComponent("TagsInput")!
  const _directive_custom_popover = _resolveDirective("custom-popover")!

  return (_ctx.isTagsEnabled)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _withDirectives(_createVNode(_component_TagsInput, {
              data: _ctx.patientTags,
              tags: _ctx.selectedTags,
              onUpdateTags: _ctx.updateTags,
              placeholder: "Start Typing...",
              "open-on-focus": true
            }, null, 8 /* PROPS */, ["data", "tags", "onUpdateTags"]), [
              [_directive_custom_popover, _ctx.sanitizeMarkup(_ctx.tagsTooltip)]
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}